import { render, staticRenderFns } from "./PilarCard.vue?vue&type=template&id=2d687f6a&scoped=true"
import script from "./PilarCard.js?vue&type=script&lang=js&external"
export * from "./PilarCard.js?vue&type=script&lang=js&external"
import style0 from "./PilarCard.scss?vue&type=style&index=0&id=2d687f6a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d687f6a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Image/Image.vue').default})
